import { OrderScenario } from '@pepperhq/types-sdk';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store';
import { useRouteScenario } from './useRouteScenario';

export const usePrepTimePadding = () => {
    const { prepTimePadding, timeSlot } = useSelector((state: ApplicationState) => state.basket);
    const [scenario] = useRouteScenario();

    const checkPadding = React.useCallback(
        (timePadding: number) =>
            (scenario === OrderScenario.PREORDER ||
                scenario === OrderScenario.DINE_IN ||
                scenario === OrderScenario.DELIVERY) &&
            !timeSlot &&
            timePadding > (prepTimePadding ?? 0),
        [scenario, timeSlot, prepTimePadding]
    );
    return { checkPadding };
};
